var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":"18","color":_vm.color,"dark":""}},[_c('div',{staticClass:"text-style"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }